import { render, staticRenderFns } from "./HangYeNews.vue?vue&type=template&id=58538d71&scoped=true"
import script from "./HangYeNews.vue?vue&type=script&lang=js"
export * from "./HangYeNews.vue?vue&type=script&lang=js"
import style0 from "./HangYeNews.vue?vue&type=style&index=0&id=58538d71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58538d71",
  null
  
)

export default component.exports